// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1Lv-Y","amount":"Amount_amount__2DXLY","tip":"Amount_tip__2Qgft","tipHeader":"Amount_tipHeader__2GG2V","tipsWrap":"Amount_tipsWrap__1WDNp"};